import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search"]

  openModal(event) {
    const brandId = event.currentTarget.dataset.brandId
    const brandName = event.currentTarget.dataset.brandName

    const form = document.getElementById('duplicate-form')
    if (form) {
      form.action = `/admin/brands/${brandId}/duplicate`
    }

    this.prefillExistingBrand()

    window.dispatchEvent(new CustomEvent('open-duplicate-modal', {
      detail: { brandId: brandId, brandName: brandName }
    }))
  }

  // Start the modal's brand picker on whatever brand was found with the duplicate search above
  prefillExistingBrand() {
    const existingBrandSelect = document.getElementById('existing_brand_id')?.tomselect
    if (!existingBrandSelect) return

    existingBrandSelect.clear(true)

    const searchSelect = this.hasSearchTarget ? this.searchTarget.tomselect : null
    const searchedBrandId = searchSelect?.getValue()
    if (!searchedBrandId) return

    existingBrandSelect.addOption(searchSelect.options[searchedBrandId])
    existingBrandSelect.setValue(searchedBrandId, true)
  }

  openEditModal(event) {
    const dataset = event.currentTarget.dataset
    const brandId = dataset.brandId

    const form = document.getElementById('edit-brand-form')
    if (form) {
      form.action = `/brands/${brandId}`
    }

    window.dispatchEvent(new CustomEvent('open-edit-modal', {
      detail: {
        brandId,
        brandName: dataset.brandName,
        brandUrl: dataset.brandUrl || '',
        brandCountry: dataset.brandCountry || '',
        brandCrueltyFree: dataset.brandCrueltyFree === 'true',
        brandSlug: dataset.brandSlug || ''
      }
    }))
  }
}
